import { Table } from "antd";
import React from "react";

function mapJobParametersToTableData(jobParameters) {
  if (!jobParameters || !jobParameters.values) return [];

  let dataSource = [];
  let keyCounter = 1;

  Object.entries(jobParameters.values).forEach(([sectionName, fields]) => {
    // Add section header
    dataSource.push({
      key: `header-${keyCounter++}`,
      parameter: sectionName,
      value: "",
      isHeader: true,
    });

    // Add each field in the section
    Object.values(fields).forEach((field) => {
      dataSource.push({
        key: `row-${keyCounter++}`,
        parameter: field.text,
        value: field.value,
        isHeader: false,
      });
    });
  });

  return dataSource;
}

const columns = [
  {
    title: "",
    dataIndex: "parameter",
    key: "parameter",
    render: (text, record) => {
      if (record.isHeader) {
        return <span style={{ color: "#e03540" }}>{text}</span>;
      }
      return text;
    },
    onCell: (record) => {
      if (record.isHeader) {
        return { colSpan: 2 };
      }
      return {};
    },
  },
  {
    title: "",
    dataIndex: "value",
    key: "value",
    render: (text, record) => {
      if (record.isHeader) return null;
      return text;
    },
    onCell: (record) => {
      if (record.isHeader) {
        return { colSpan: 0 };
      }
      return {};
    },
  },
];

const JobParametersM500 = ({ jobParameters }) => {
  const dataSource = mapJobParametersToTableData(jobParameters);

  const calcHeight = -150;
  const tableHeight = `calc(${calcHeight}px + 100vh)`;
  return (
    <div
      className="job-parameters-table"
      style={{
        height: tableHeight,
        position: "relative",
      }}
    >
      <Table
        columns={columns}
        dataSource={dataSource}
        pagination={false}
        bordered={false}
        className="welding-parameters-table"
        showHeader={false}
        scroll={{ y: tableHeight }}
      />
    </div>
  );
};

export default JobParametersM500;
